import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=022e64d9&scoped=true"
import script from "./MetricCard.vue?vue&type=script&lang=js"
export * from "./MetricCard.vue?vue&type=script&lang=js"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=022e64d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e64d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022e64d9')) {
      api.createRecord('022e64d9', component.options)
    } else {
      api.reload('022e64d9', component.options)
    }
    module.hot.accept("./MetricCard.vue?vue&type=template&id=022e64d9&scoped=true", function () {
      api.rerender('022e64d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/panels/MetricCard.vue"
export default component.exports